<nz-card>
  <div>
    <div class="d-flex align-items-end justify-content-end m-b-10">
      <button nz-button nzType="primary" (click)="add()"><i-tabler name="plus" class="tb-icon tb-icon-m center"></i-tabler>Thêm mới</button>
    </div>
    <app-table [tableConfig]="tableConfig"
               [tableData]="userList"
               [changeDetect]="tableConfig.loading"
               (changePageNum)='getList()'
               (doSort)="getList(false, $event)"
    >
      <!--        Filter    -->
      <ng-template name="filter.name">
        <nz-input-group [nzPrefix]="suffixIconSearch">
          <input type="text" nz-input placeholder="Nhập tên" [(ngModel)]="filter.name"
                 (ngModelChange)="filterChange($event)">
        </nz-input-group>
      </ng-template>
      <ng-template name="filter.userName">
        <nz-input-group [nzPrefix]="suffixIconSearch">
          <input type="text" nz-input placeholder="Nhập username" [(ngModel)]="filter.userName"
                 (ngModelChange)="filterChange($event)">
        </nz-input-group>
      </ng-template>
      <ng-template name="filter.email">
        <nz-input-group [nzPrefix]="suffixIconSearch">
          <input type="text" nz-input placeholder="Nhập email" [(ngModel)]="filter.email"
                 (ngModelChange)="filterChange($event)">
        </nz-input-group>
      </ng-template>
      <ng-template name="filter.phoneNumber">
        <nz-input-group [nzPrefix]="suffixIconSearch">
          <input type="text" nz-input placeholder="Nhập số ĐT" [(ngModel)]="filter.phoneNumber"
                 (ngModelChange)="filterChange($event)">
        </nz-input-group>
      </ng-template>
      <ng-template name="filter.status">
        <nz-select style="width: 100%" [(ngModel)]="filter.status" (ngModelChange)="filterChange($event)">
          <nz-option nzLabel="Tất cả" [nzValue]="-1"></nz-option>
          <nz-option *ngFor="let status of userStatus" [nzLabel]="status.name" [nzValue]="status.value"></nz-option>
        </nz-select>
      </ng-template>
      <ng-template name="filter.userRole">
        <nz-select style="width: 100%" [(ngModel)]="filter.userRole" (ngModelChange)="filterChange($event)">
          <nz-option nzLabel="Tất cả" [nzValue]="'ALL'"></nz-option>
          <nz-option *ngFor="let role of userRoleTypes" [nzLabel]="role.name" [nzValue]="role.value"></nz-option>
        </nz-select>
      </ng-template>
      <ng-template name="filter.actionTmpl">
        <div class="text-center">
          <button nz-button nzType="link" (click)="reload()" >
            <i-tabler class="tb-icon tb-icon-m center mr-1" name="reload"></i-tabler>
            Reload
          </button>
        </div>

      </ng-template>
      <!--       -->

      <!--  Custom Row      -->
      <ng-template name="statusTmpl" let-status="status">
        <nz-badge class="p-h-15" [nzStatus]="userStatus|where:['value', status] | pluck: 'badge'"
                  [nzText]="userStatus|where:['value', status]|pluck: 'name'"></nz-badge>
      </ng-template>
      <ng-template name="userRoleTmpl" let-role="userRole">
        <nz-tag nzColor="{{userRoleTypes|where:['value', role] | pluck: 'color'}}">{{ userRoleTypes|where:['value', role] | pluck: 'name' }}</nz-tag>
      </ng-template>
      <ng-template name="actionTmpl" let-data="data">
        <a class="text-gray font-size-18" nz-dropdown nzPlacement="bottomCenter" nzTrigger="click"
           [nzDropdownMenu]="action">
          <i nz-icon nzType="ellipsis" theme="outline"></i>
        </a>
        <nz-dropdown-menu #action="nzDropdownMenu">
          <ul nz-menu nzSelectable>
            <li nz-menu-item (click)="view(data)">
                <span>
                  <i nz-icon nzType="eye" theme="outline"></i>
                  <span class="m-l-10">Xem thông tin</span>
                </span>
            </li>
            <li nz-menu-item (click)="edit(data)">
                <span>
                  <i nz-icon nzType="edit" theme="outline"></i>
                  <span class="m-l-10">Chỉnh sửa</span>
                </span>
            </li>
            <li nz-menu-divider></li>
            <li nz-menu-item *ngIf="data.status === userStatusType.INACTIVE" (click)="verify(data)">
                <span>
                  <i nz-icon nzType="check-circle" theme="outline"></i>
                  <span class="m-l-10">Kích hoạt tài khoản</span>
                </span>
            </li>
            <li nz-menu-item *ngIf="data.status === userStatusType.ACTIVE" (click)="lockOrUnlock(data)">
                <span>
                  <i nz-icon nzType="lock" theme="outline"></i>
                  <span class="m-l-10">Khóa tài khoản</span>
                </span>
            </li>

            <li nz-menu-item *ngIf="data.status === userStatusType.LOCKED" (click)="lockOrUnlock(data)">
                <span>
                  <i nz-icon nzType="unlock" theme="outline"></i>
                  <span class="m-l-10">Mở khóa tài khoản</span>
                </span>
            </li>
            <li nz-menu-divider></li>
            <li nz-menu-item (click)="delete(data)">
                <span>
                  <i nz-icon nzType="delete" theme="outline"></i>
                  <span class="m-l-10">Xóa</span>
                </span>
            </li>
          </ul>
        </nz-dropdown-menu>
      </ng-template>
      <!--        -->
    </app-table>
  </div>
</nz-card>

<ng-template #suffixIconSearch>
  <span nz-icon nzType="search"></span>
</ng-template>
